export default chartMonth

/** @ngInject */
function chartMonth(Chart) {
    return ({
        restrict: 'E',
        template: '<div ng-class="{active: active}"><p>{{month}}</p></div>',
        scope: {
            index: '=',
            month: '=',
        },
        link(scope) {
            scope.active = false
            return Chart.watch.activeIndex((newIndex) => {
                if (newIndex === scope.index) {
                    scope.active = true
                } else {
                    scope.active = false
                }
                if (!scope.$$phase) {
                    return scope.$digest()
                }
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/chart-month/directive.js